<template>
  <div
    :class="[
      'anz-badge anz-badge-orange anz-text-uppercase anz-mt-xxxs anz-mr-s',
      size,
      className,
    ]"
  >
    {{ $translate('profile.labels.vip') }}
  </div>
</template>

<script>
export default {
  name: 'APremium',
  props: {
    className: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'anz-badge-sm',
    },
  },
}
</script>
